/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import OurProducts from "./OurProducts.container";

export default OurProducts;
